module.exports = __webpack_public_path__ + "static/domination-ny-0b799e610fb8ba71b6ce534765f0b195.jpg";